<template lang="pug">
<div>
	div(class="form-group fg-500" )
		span
			label From Date
			input(id="d_fromDate" class="date-range" size="sm" type="date"   @change="m_fromDateChange()")
			label To Date					
			input(id="d_toDate" class="date-range" size="sm" type="date" @change="m_toDateChange()")
			label Tasks:
			select(class="input-value" id="d_taskOption" name="d_taskOption" placeholder="All" @change="m_taskOption()")
				option(value='All') All
				option(value='Major') Major
			label View Mode:	
			<button type="button" class="btn btn-sm btn-light" @click="m_clickDayView">Day</button>
			<button type="button" class="btn btn-sm btn-light"  @click="m_clickWeekView">Week</button>
			<button type="button" class="btn btn-sm btn-light" @click="m_clickMonthView">Month</button>
			b-button(class="btn-refresh" variant="none" title="Refresh" @click="m_refresh()")
				fa-icon(icon="sync")
	<div id="ganttApp">
		<svg id="gantt"></svg>
		//- Loading
		kt-spinner(v-if="d_loading" p_txt="Tasks")
		//- Error
		div(v-else-if="d_errMessage" class="error")
			p(class="text-danger") Something went wrong ☹
			p(class="my-1 text-grey5") {{d_errMessage}}	
			p() Please try again or refresh your browser session.
		div(v-else-if="d_taskData.length==0" class="nodata")
				| No data found 
	</div>

</div>
</template>
<script>
import Gantt from 'frappe-gantt'
import date_utils from 'frappe-gantt/src/date_utils.js';
import {fn_getTaskResources} from "@/utils/api.js";
import {library} from '@fortawesome/fontawesome-svg-core';
import * as icons from "@/utils/icons.js";
import {api_baseURL, client_subdomain, fn_get_IdToken} from "@/utils/init.js";
library.add(icons);
export default {
  name: "kt-ganttView",
  created(){
		//switch(this.d_taskData.taskSource) {
		switch(this.d_Source) {
			case 'All':
				this.d_taskSource=null;
				this.d_columns=['teamMember','utilization','completion'];
				this.d_customHMTL=(task) => {
									var bgColor;
									if(task.progress==100)
										bgColor='#228B22'   //'#355E3B'
									else
									if(task.progress>=task.expectedProgress) 
										bgColor='#32CD32'
									else
										bgColor='orange';
										var startDate = date_utils.format(date_utils.parse(task.start), 'MMM D', 'en');
										var endDate = date_utils.format(date_utils.parse(task.end), 'MMM D', 'en');
										const subtitle = startDate + ' - ' + endDate;
										const expectedProgress=task.expectedProgress?`${task.expectedProgress}%`:' ';
										const progress=task.progress?`${task.progress}%`:' ';
										return `<div class="popup-wrapper">
												<a class="title">${task.name}</a>
												<div class="subtitle">${subtitle}</div>
												<div class="expectedProgress">Expected progress:${expectedProgress}</div>
												<div class="actualProgress" style="color:white;background-color:${bgColor};">Actual progress:${progress}</div>
												</div>
											`;
											};
			break;
			case 'opportunity':
				this.d_taskSource='opportunity';
				this.d_columns=['opportunity#','completion'];
				this.d_customHMTL=(task) => {
									var bgColor;
									if(task.progress==100)
										bgColor='#228B22'   //'#355E3B'
									else
									if(task.progress>=task.expectedProgress) 
										bgColor='#32CD32'
									else
										bgColor='orange';
										var startDate = date_utils.format(date_utils.parse(task.start), 'MMM D', 'en');
										var endDate = date_utils.format(date_utils.parse(task.end), 'MMM D', 'en');
										const subtitle = startDate + ' - ' + endDate;
										const expectedProgress=task.expectedProgress?`${task.expectedProgress}%`:' ';
										const progress=task.progress?`${task.progress}'%`:' ';
										return `<div class="details-container">
												<a class="title">${task.name}</a>
												<div class="subtitle">${subtitle}</div>
												<div class="assignee">Assignee:${task.assignee}</div>
												<div class="expectedProgress">Expected progress:${expectedProgress}</div>
												<div class="actualProgress" style="color:white;background-color:${bgColor};">Actual progress:${progress}</div>
												</div>
											`;
											};
			break;
			}	
	
  },
  mounted() {
  fn_getData(this);
  //fn_createGantt(this);
  //this.m_createGantt();
  },
	data() {
	return {
	d_Source: 'All',
	d_taskSource:null,
	d_viewMode: 'Day',
	d_taskOption:'All',
	d_fromDate: null,
	d_toDate: null,
	d_loading: null,
	d_teamMemberId:null,
	d_taskData:[],
	d_noDataFound:false,
	d_errMessage:null,
  }},
  props: {
		p_taskData:{},
		p_columns: [],
		p_customHTML:null
	},
  methods: {
		m_createGantt(){
				this.gantt = new Gantt("#gantt", this.d_taskData, {
				columns: this.d_columns,
				view_mode: this.gantt?this.gantt.options.view_mode:this.d_viewMode,
				view_modes: ['Day'],
				arrow_curve: 14,
				custom_popup_html: this.d_customHMTL,
				taskOption:this.d_taskOption
			})
			},
		m_clickDayView(){this.gantt.change_view_mode('Day');},
		m_clickWeekView(){this.gantt.change_view_mode('Week');},
		m_clickMonthView(){this.gantt.change_view_mode('Month');},
		m_fromDateChange(){
							this.d_fromDate=d_fromDate.value;
							},
		m_toDateChange(){
						this.d_toDate=d_toDate.value;
						},
		m_refresh(){
			console.log('Refreshing');
			fn_getData(this);
		},
		m_taskOption(){
			this.d_taskOption=d_taskOption.value;
			fn_createGantt(this, this.d_taskData);
		}
  },
  watch: {
         d_viewMode(nv,ov){console.log('Inwatch'); this.gantt.change_view_mode(nv);}	 
	}
};
function fn_getData(vc) {
	vc.d_loading = true;
	let params={taskSource:vc.d_taskSource,teamMemberId:vc.d_teamMemberId,fromDate:vc.d_fromDate, toDate:vc.d_toDate};
	vc.d_taskData=[];
	fn_getTaskResources(params).then(resp => {
		vc.d_loading = null;
                if (resp.error) {
					vc.d_errMessage = resp.error;
					vc.d_loading = false;
					return;
			}
		if(resp.recordData){
		resp.recordData.forEach(rec=>{
		var d_rec=rec;
		d_rec.custom_class=rec.taskSource;
		vc.d_taskData.push(d_rec);
		});
		fn_createGantt(vc, vc.d_taskData);
		}
		else {
				document.querySelector('#gantt').innerHTML = '';
				}	
	});
	}
function fn_createGantt(vc, tasks){
			vc.gantt = new Gantt("#gantt", tasks, {
			columns: vc.d_columns,
			view_mode: vc.gantt?vc.gantt.options.view_mode:vc.d_viewMode,
			view_modes: ['Day'],
			arrow_curve: 14,
			custom_popup_html: vc.d_customHMTL,
			taskOption:vc.d_taskOption
			})
			}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.gantt .tick {
  stroke: #666;
}
.opportunity .bar { fill: #1d79bf !important; }
.opportunity .bar-progress { fill: #0e3e63 !important; }

.project .bar { fill: #81ba6a !important; }       
.project .bar-progress { fill: #1a4708 !important; } 


.account .bar { fill: #FF8E76!important; }
.account .bar-progress { fill: #D95B43 !important; }

.jeff .bar { fill: #87576A !important } 
.jeff .bar-progress { fill: #542437 !important } 

.eric .bar {  fill: #86AAAD !important } 
.eric .bar-progress {  fill: #53777A !important } 

.calendar .bar {  fill: #F35C75 !important }
.calendar .bar-progress {  fill: #C02942 !important }
div.form-group {
		min-width: 300px;
		display: flex;
		flex-wrap: wrap;
		> label {
			min-width: 130px;
			margin: auto 0;
		}
     }
.date-range {
			margin-right: 0.3em;
			opacity: 0.5;
			&:hover {
			opacity: unset;
				}
			}
.input-value {
			margin-right: 0.3em;
			opacity: 0.5;
			&:hover {
			opacity: unset;
				}
			}
.btn-group {
			margin-left: 0.3em;
			opacity: 0.7;
			//border: solid 0.001em;
			&:hover {
			opacity: unset;
				}
			}
.btn-refresh
		{
		font-size: 1em;
		margin-left: 0.5em;
		margin-right: 0.5em;
		padding: 0em 0.3em;
		border: solid 0.001em;
		border-radius: 0.15em;
		//opacity: 0.3;
			&:hover {
			opacity: unset;
				}
	}
.div.error,
.div.nodata {
			width: 100%;
			font-size: 5em;
			text-align: center;
			padding: 0.5em 0;
		}

</style>
